export function desktopInvalidTokenCheckAndHandler(code: string) {
  if (code === 'IAM_FAILED') {
    window.vue.$router.push({
      name: 'pcResult',
      query: {
        result: 'IAM_FAILED',
      },
    })
    return true
  }
  return false
}

export function desktopInvalidTokenCheckAndHandlerV2(code: string) {
  if (code === 'IAM_FAILED') {
    window.vue.$router.push({
      name: 'webResultV2',
      query: {
        result: 'IAM_FAILED',
      },
    })
    return true
  }
  return false
}
